import { createAsyncThunk } from "@reduxjs/toolkit";
import { feesApi } from "../../api/requests";
import { FeesTableSchema, FilterType } from "../../types/types";
import { RootState } from "../store";
import { formatDateToString } from "../../helpers/date";
import { ActionTypes } from "./types";

export const getFeesThunk = createAsyncThunk<FeesTableSchema[], { existingFeeGroup?: number }, { state: RootState }>(ActionTypes.FETCH_FEES, async ({ existingFeeGroup }, thunkAPI) => {
    try {
        const { feeGroup, description, validUntil, currency } = thunkAPI.getState().table.filters;
        const feeGroups = thunkAPI.getState().table.feeGroups;
        const { language } = thunkAPI.getState().settings;

        const res = await feesApi.getFees({ language, currency: currency, searchText: description, validAt: validUntil ? formatDateToString(validUntil) : null, feeGroupCode: existingFeeGroup ? existingFeeGroup.toString() : feeGroup ? feeGroup.toString() : null, feeCode: null });

        if (!res.ok) {
            throw new Error('Failed to fetch Fees');
        }
        return res.json();
    } catch (err) {
        return thunkAPI.rejectWithValue('Failed to fetch Fees');
    }
})

export const getFeeGroupsThunk = createAsyncThunk<FilterType[], void, { state: RootState }>(ActionTypes.FETCH_FEE_GROUPS, async (_, thunkAPI) => {
    try {
        const { language } = thunkAPI.getState().settings;

        const res = await feesApi.getFeeGroups({ language });

        if (!res.ok) {
            throw new Error('Failed to fetch Fees');
        }

        type BackendResponseData = { feeGroups: { feeGroupCode: string, feeCodeDescription: string }[] }

        const data: BackendResponseData = await res.json();

        const transformedData = data.feeGroups.map((group: any, index: number) => ({
            id: index + 1,
            label: group.feeGroupDescription,
            value: group.feeGroupCode,
        }));

        return transformedData;
    } catch (err) {
        return thunkAPI.rejectWithValue('Failed to fetch Fees');
    }
})